export const FuelKey = {
  DEVICE_TYPE: 'deviceType',
  NO_UNITS: 'numberOfUnit',
  FUEL_TYPE: 'fuelType',
  FUEL_USED: 'fuelUsed',
  QUANTITY_TF: 'quantity',
  COST_TF: 'fuelcost',
  STATUS: 'status',
  YEAR: 'year',
  FACILITY: 'facility',
  COMMENT: 'comment'
};
export const FuelLabel = {
  DEVICE_TYPE: 'Device Type',
  NO_UNITS: 'No. of Units',
  FUEL_TYPE: 'Fuel Type',
  FUEL_USED: 'Fuel Used',
  QUANTITY_TF: 'Quantity',
  COST_TF: 'Fuel Cost',
  STATUS_COMMENTS: 'Status & Comments',
  FULL_INFO: 'Full Info',
  STATUS: 'Status',
  COMMENT: 'Comment'
};
